import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import React from 'react';

import { useNamedLogger } from '@eluve/logger';

import { useFlagRetrievalMetrics } from './flagRetrievalMetrics';

export interface SessionlessAnalyticsProviderProps {
  children: React.ReactNode;
  apiKey: string;
  apiHost: string;
}

export const SessionlessAnalyticsProvider: React.FC<
  SessionlessAnalyticsProviderProps
> = ({ children, apiKey, apiHost }) => {
  const logger = useNamedLogger('SessionlessAnalyticsProvider');

  useFlagRetrievalMetrics(apiHost, logger);

  const postHogConfig = {
    api_host: apiHost,
    autocapture: false,
    person_profiles: 'identified_only' as const,
    session_recording: {
      maskTextSelector: '#email',
    },
  };

  // Reuse existing PostHog client if already loaded
  if (posthog.__loaded) {
    posthog.set_config(postHogConfig);

    return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
  }

  return (
    <PostHogProvider
      apiKey={apiKey}
      options={{
        ...postHogConfig,
        loaded: () => {
          logger.info('Posthog loaded');
        },
      }}
    >
      {children}
    </PostHogProvider>
  );
};
